import { defineComponent as _defineComponent } from 'vue'
import SuccessItem from '@/components/Success/SuccessItem.vue';
import { computed } from 'vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const storeSuccess = computed(() => store.getters.storeSuccess);

return { __sfc: true,storeSuccess, SuccessItem }
}

})